<template>
  <Modal title="学生请假" v-model="visible" width="880">
    <Form ref="leaveForm" class="form" :label-width="80"
      :model="leaveParam" :rules="leaveRule">
      <Row>
        <Col span="4" style="height: 50px;">
        <span>请假类型：请单节课</span>
        </Col>
      </Row>
      <Row>
        <Col span="4" style="height: 50px; width: 400px">
        <span  style="margin:0px 20px;">请假课程：{{leaveParam.beginTime}}</span>
        <span>{{leaveParam.title}}</span>
        </Col>
      </Row>
      <!--<Row>-->
        <!--<Col :span="16">-->
          <!--<Form-item prop="isSixHoursAgo" label="是否3小时前：">-->
            <!--<RadioGroup v-model="leaveParam.isSixHoursAgo">-->
              <!--<Radio label="0">-->
                <!--<span>否</span>-->
              <!--</Radio>-->
              <!--<Radio label="1">-->
                <!--<span>是</span>-->
              <!--</Radio>-->
            <!--</RadioGroup>-->
          <!--</Form-item>-->
        <!--</Col>-->
      <!--</Row>-->
      <Row>
        <Col :span="16">
          <Form-item label="请假原因" prop="remark">
            <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
              placeholder="长度不要超过100个字符"
              v-model="leaveParam.remark" ></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loading" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UserOneLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openId: {
        type: Number,
        default: false
      },
      title: {
        type: String,
        default: false
      },
      beginTime: {
        type: Number,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loading: false,
        leaveParam: {
          openId: '',
          remark: '',
          title: '',
          beginTime: '',
          isSixHoursAgo: 0,
        },
        leaveRule: {
          remark: [
            { type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      add () {
        let self = this
        self.loading = true
        self.$refs.leaveForm.validate((valid) => {
          if (!valid) {
            self.loading = false
            return
          }
          this.loading = true
          self.$http.post('/bookUserLeaveTime/addByOpenedId', {
            openedId: self.leaveParam.openId,
            remark: self.leaveParam.remark,
            isSixHoursAgo: self.leaveParam.isSixHoursAgo
          }).then(function (res) {
            if (res && res.status === 'ok') {
              self.loading = false
              self.$Message.success('请假成功!')
              self.visible = false
              self.successCallback()
            } else {
              self.loading = false
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.leaveParam.remark = ''
          this.$emit('on-close', val)
        }
        this.$emit('input', val)
      },
      openId (val) {
        this.leaveParam.openId = val
      },
      title (val) {
        this.leaveParam.title = val
      },
      beginTime (val) {
        let $moment = this.$moment
        this.leaveParam.beginTime = $moment(val, 'X').format('YYYY-MM-DD HH:mm')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserOneLeaveModal.vue?60f557fc